<template>
  <layout>
    <page-header>
      <template slot="header">
        <h4 class="mr-4">
          <i class="icon-percent mr-2"></i>
          {{ $t('company.commissions.title') }}
        </h4>
      </template>
    </page-header>
    <div class="content">
      <b-row>
        <b-col>
          <b-card>{{ $t('companies.company_pay') }}</b-card>
          <b-card no-body>
            <b-table ref="tableMe" v-bind="tablePropsMe" responsive>
              <template slot="id" slot-scope="{ item }">
                <router-link
                  :to="{ name: 'companies.edit', params: { id: item.id } }"
                >
                  {{ item.id }}
                </router-link>
              </template>
              <template slot="company_credit" slot-scope="{ item }">
                <router-link
                  :to="{
                    name: 'companies.commissions',
                    params: { id: item.id },
                  }"
                >
                  {{ item.company_credit }}&nbsp;{{ currency_label }}
                </router-link>
              </template>
              <template slot="action" slot-scope="{ item }">
                <button
                  v-if="canGenerateInvoice(item)"
                  class="btn btn-link"
                  @click="generateInvoice(item)"
                >
                  Generate invoice
                </button>
              </template>
            </b-table>
          </b-card>
        </b-col>

        <b-col>
          <b-card>{{ $t('companies.pay_companies') }}</b-card>
          <b-card no-body>
            <b-table ref="tableThem" v-bind="tablePropsThem" responsive>
              <template slot="id" slot-scope="{ item }">
                <router-link
                  :to="{ name: 'companies.edit', params: { id: item.id } }"
                >
                  {{ item.id }}
                </router-link>
              </template>
              <template slot="company_credit" slot-scope="{ item }">
                <router-link
                  :to="{
                    name: 'companies.commissions',
                    params: { id: item.id },
                  }"
                >
                  {{ item.company_credit }}&nbsp;{{ currency_label }}
                </router-link>
              </template>
              <template slot="action" slot-scope="{ item }">
                <button
                  v-if="canGenerateInvoice(item)"
                  class="btn btn-link"
                  @click="generateInvoice(item)"
                >
                  Generate invoice
                </button>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import CommissionsApiList from './CommissionsApiList'
import BookingAmount from '../bookings/BookingAmount'
import CommissionsNotice from './CommissionsNotice'
import ValueDate from '../components/values/ValueDate'
import OrderFinalAmount from '../orders/OrderFinalAmount'

export default {
  name: 'Commissions',

  components: {
    OrderFinalAmount,
    ValueDate,
    CommissionsNotice,
    AdminTable,
    BookingAmount,
  },

  data() {
    return {
      currency: null,
      currency_label: null,
      // totals: {},
      // total_payments: {},
      unpaidInvoiceId: null,
      minBalance: 100,

      // Table resource configuration
      tablePropsMe: {
        items: () => {
          return new CommissionsApiList()
            .setParameters({
              //company_id: this.$route.params.id,
            })
            .all()
            .then(result => {
              this.onApiResult(result)
              return result.to_me
            })
        },
        fields: [
          {
            key: 'id',
            label: this.$t('general.id'),
          },
          {
            key: 'name',
            label: this.$t('companies.name'),
          },
          {
            key: 'count',
            label: 'Bookings',
          },
          {
            key: 'company_credit',
            label: this.$t('general.summary'),
            class: 'font-bold',
          },
          {
            key: 'action',
            label: '',
          },
        ],
      },
      tablePropsThem: {
        items: () => {
          return new CommissionsApiList()
            .setParameters({
              //company_id: this.$route.params.id,
            })
            .all()
            .then(result => {
              this.onApiResult(result)
              return result.to_them
            })
        },
        fields: [
          {
            key: 'id',
            label: this.$t('general.id'),
          },
          {
            key: 'name',
            label: this.$t('companies.name'),
          },
          {
            key: 'count',
            label: 'Bookings',
          },
          {
            key: 'company_credit',
            label: this.$t('general.summary'),
            class: 'font-bold',
          },
          {
            key: 'action',
            label: '',
          },
        ],
      },
    }
  },

  computed: {
    isPending(company) {
      return company.count > 0
    },
    balance(company) {
      return (
        company.company_amount -
        company.cash_payments -
        company.company_penalty_amount
      )
    },

    isAdmin() {
      return this.$allows('administer')
    },
  },

  methods: {
    canGenerateInvoice(company) {
      return (
        this.isAdmin ||
        this.balance(company) < 0 ||
        (company.unpaid_invoice_id === null &&
          this.balance(company) >= this.minBalance)
      )
    },
    onApiResult(result) {
      this.currency = result.currency
      this.currency_label = result.currency_label
      this.unprocessed = result.unprocessed
      // this.totals = result.totals
      // this.total_payments = result.total_payments
      // this.unpaidInvoiceId = result.unpaid_invoice_id
    },
    generateInvoices() {
      this.$uiBlocker(
        this.$http.post('company/process').then(response => {
          this.$toast.success(response.data.message)
          this.unprocessed = response.data.unprocessed
        }),
        this.$refs.table,
      )
    },
    async generateInvoice(company) {
      const { value } = await this.$alert.question(
        this.$t('company.commissions.request_now_confirm'),
        '',
        {
          showCancelButton: true,
        },
      )

      if (value) {
        new CommissionsApiList()
          .process([], company.id)
          .then(result => {
            this.$toast.success(result.message)
            this.unprocessed = result.unprocessed
            this.$refs.tableMe.refresh()
            this.$refs.tableThem.refresh()
          })
          .catch(response => {
            this.$toast.error(response.data.message)
          })
      }
    },

    goToUnpaid() {
      this.$router.push({
        name: 'company-orders-pay',
        params: {
          id: this.unpaidInvoiceId,
        },
      })
    },
  },
}
</script>
